import { GetFactoryTopSaleReportData } from "services/interface";
import { ApexOptions } from "apexcharts";
import React, { FC } from "react";
import ReactApexcharts from "react-apexcharts";
import { Empty } from "antd";
import { numberFormat, stringToCommaFormat, stringWithCommaFormat } from "utils/nuberFormat";

interface ChartProductProps {
  data: GetFactoryTopSaleReportData[] | undefined;
  isLoading: boolean;
}

const ChartProduct: FC<ChartProductProps> = ({ data }) => {
  const arrayTotalPrice = data?.map((item) => item.total_price);

  const arrayProductName = data?.map((item) => item.product_name);

  const series = [
    {
      name: "Top 5 Product",
      data: arrayTotalPrice || [],
    },
  ];

  const options: ApexOptions = {
    chart: {
      parentHeightOffset: 0,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        borderRadius: 8,
        barHeight: "70%",
        horizontal: true,
        distributed: true,
        // startingShape: 'rounded'
      },
    },
    dataLabels: {
      offsetY: 8,
      style: {
        fontWeight: 500,
        fontSize: "0.875rem",
      },    
      formatter: (val:number) => `฿${numberFormat(val)}`,
    },
    grid: {
      strokeDashArray: 8,
      // borderColor: theme.palette.divider,
      xaxis: {
        lines: { show: true },
      },
      yaxis: {
        lines: { show: false },
      },
      padding: {
        top: -18,
        left: 21,
        right: 33,
        bottom: 10,
      },
    },
    colors: ["#787eff", "#83e542", "#fdbe42", "#40cdfa", "#ff625f"],
    legend: { show: false },
    states: {
      hover: {
        filter: { type: "none" },
      },
      active: {
        filter: { type: "none" },
      },
    },
    xaxis: {
      axisTicks: { show: false },
      axisBorder: { show: false },
      categories: arrayProductName || [],
      labels: {
        formatter: (val) => `฿${stringWithCommaFormat(val)}`,
        style: {
          fontSize: "0.875rem",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontWeight: 600,
          fontSize: "0.875rem",
        },
        formatter: (val) => `${numberFormat(val)}`,
      },
    },
  };

  // if(data?.length === 0) return (<div>ไม่มีข้อมูล</div>)

  return (
    <>
      {data?.length === 0 ? (
        <Empty />
      ) : (
        <ReactApexcharts
          type="bar"
          height={294}
          series={series}
          options={options}
        />
      )}
    </>
  );
};



export default ChartProduct;
